function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Math, Object, String, displayContextMenu, labelsCropped, links, selectedNode, tooltip, topPath) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['link-tooltip'] = function({
      breakdown,
      edge,
      top,
      left
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const count = breakdown ? breakdown.totalCount : edge.totalCount;;
        const percentage = $helpers.abbreviateNumber((count / edge.fromNode.totalCount) * 100);;
        const fromCount = $helpers.commaizeNumber(edge.fromNode.totalCount);;
        const edgeCount = $helpers.commaizeNumber(count);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": 'sankey-tooltip',
          "style": {
            left: `${left}px`,
            top: `${top}px`,
          },
          "class": {
            'sankey-tooltip': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'sankey-link-tooltip-path-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-node-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($helpers.renameEvents(edge.fromNode.eventString))]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sankey-link-tooltip-node-connector': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-node-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($helpers.renameEvents(edge.toNode.eventString))]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'sankey-link-tooltip-weight': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (edgeCount) + " of " + (fromCount) + " " + (percentage) + "%");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((breakdown && breakdown.timePercentilesFromStart.length) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-weight': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Median time from start " + ($helpers.formatConciseDuration(breakdown.timePercentilesFromStart[0])) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((breakdown && breakdown.timePercentilesFromPrev.length) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-weight': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Median time from previous step " + ($helpers.formatConciseDuration(breakdown.timePercentilesFromPrev[0])) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['node-label'] = function({
      node,
      nodeAttributes,
      anchorStepWeight
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": `label-${node.id}`,
          "style": {
            height: `${nodeAttributes.height}px`
          },
          "class": {
            'sankey-node-label-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.onNodeClicked,
              contextmenu: ev => $helpers.showContextMenu(ev, node),
            },
            "props": {
              node,
              nodeAttributes
            },
            "class": Object.assign({}, {
              'is-center_aligned': nodeAttributes.height <= $helpers.nodeLabelMinHeight,
              'is-in-top-path': nodeAttributes.isInTopPath,
            }, {
              'sankey-node-label': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-node-label-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sankey-node-name-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                const nodeLetterLabel = node.getLetterLabel();
                const nodeLabel = nodeLetterLabel ? $helpers.getAnchorLabelOverride(node.getAnchorIndex(), node.eventString) : $helpers.renameEvents(node.eventString);
                const isAnchorNode = node.isAnchorNode();
                const labelIcon = $helpers.getLabelIcon(node);;
                __jade_nodes = __jade_nodes.concat((!$attr(`disable-anchor-event-labels`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-node-icons': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((labelIcon) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: labelIcon
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(" ");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((nodeLetterLabel) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          text: nodeLetterLabel,
                          theme: `light`,
                          size: `small`
                        }),
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": Object.assign({}, {
                    'has-icon': !!labelIcon
                  }, {
                    'sankey-label-content': true
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-node-name': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(nodeLabel);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-label-percentages': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'sankey-node-weight': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      const weight = $helpers.abbreviateNumber(node.totalCount / anchorStepWeight * 100);
                      __jade_nodes = __jade_nodes.concat(`${weight}%`);
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `top`,
                          'max-width': `300px`
                        }),
                      }, [__vjadeSafeCode($helpers.getWeightTooltipText(weight, node.step, node.section, nodeAttributes.stepType, nodeAttributes.anchorStepIndex, nodeLabel, isAnchorNode))]));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((!$attr(`disable-lift`) && node.hasLift()) ? ((function() {
                      var __jade_nodes = [];
                      const negativeLift = node.conversionRateChange < 0;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          'negative-lift': negativeLift
                        }, {
                          'sankey-node-lift': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        const lift = $helpers.abbreviateNumber(Math.abs(node.conversionRateChange));
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            icon: $helpers.getLiftIcon(negativeLift)
                          }),
                        }));
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            placement: `top`,
                            'max-width': `300px`
                          }),
                        }, [__vjadeSafeCode($helpers.getLiftTooltipText(lift, negativeLift))]));
                        __jade_nodes = __jade_nodes.concat(`${lift}%`);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (node.segments);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'sankey-segment-value': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("b", (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (segment.label) + ":");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(` ${segment.value}`);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var segment = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'sankey-segment-value': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("b", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (segment.label) + ":");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(` ${segment.value}`);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());
              __jade_nodes = __jade_nodes.concat((selectedNode === node.id && node.breakdowns.length > 1) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-node-breakdown-percents': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (node.breakdowns);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              '--breakdown-bg-color': breakdownAttributes.color
                            },
                            "class": {
                              'sankey-node-breakdown-percent': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(`${$helpers.abbreviateNumber(breakdown.totalCount / node.totalCount * 100)}%`);
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                placement: 'left',
                                'max-width': '200px'
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(breakdownAttributes.name)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var breakdown = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": {
                                  '--breakdown-bg-color': breakdownAttributes.color
                                },
                                "class": {
                                  'sankey-node-breakdown-percent': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(`${$helpers.abbreviateNumber(breakdown.totalCount / node.totalCount * 100)}%`);
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    placement: 'left',
                                    'max-width': '200px'
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(breakdownAttributes.name)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const steps = $component.data.steps;;
    const breakdowns = $component.data.breakdowns;;
    const addStepsText = `Add Steps`;;
    return {
      value: (h("div", {
        "on": {
          mouseleave: $helpers.onMouseLeave,
          mousemove: $helpers.onMouseMove,
        },
        "hook": {
          insert: $helpers.onSankeyInsert
        },
        "class": Object.assign({}, {
          'is-loaded': steps && !$helpers.isEmptyFlow() ? labelsCropped && links !== null : true,
          'is-reverse': $attr(`reverse`),
          'is-top-path-mode': topPath.size > 0,
        }, {
          'sankey': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((steps) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.isEmptyFlow()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `empty-state`
              }),
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            const anchorStep = $helpers.getFlowAnchorStep();;
            const anchorStepWeight = anchorStep.weight;;
            const weight = $helpers.abbreviateNumber(anchorStepWeight);;
            const weightLabel = $helpers.pluralize(`Event`, anchorStepWeight);; /*  tooltip for when hovering over node links */
            __jade_nodes = __jade_nodes.concat((tooltip) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['link-tooltip'].call(this, tooltip));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-scroll-control", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'scroll-by': $helpers.getScrollByAmount(),
                top: `90%`,
              }),
              "props": {
                mousemoveEl: $helpers.getMousemoveElement(),
                scrollEl: $helpers.getScrollElement(),
              },
            })); /*  wrapper for scrolling inner table contents */
            __jade_nodes = __jade_nodes.concat(h("div", {
              "key": `sankey`,
              "on": {
                scroll: $helpers.closeContextMenu
              },
              "hook": {
                insert: $helpers.onScrollerInsert
              },
              "class": {
                'sankey-table-scroller': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "hook": {
                  insert: $helpers.onTableInserted,
                  postpatch: $helpers.onTablePatched,
                },
                "class": {
                  'sankey-table': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((breakdowns.length > 1) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-legend': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-chart-legend", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        theme: $helpers.ChartLegendTheme.ReadOnly,
                        'sections': JSON.stringify($helpers.getBreakdownSections()),
                        'style-override': require('./legend.styl?inline'),
                        'wrap-labels': true,
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-table-content': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-table-headers': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (steps);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, step, stepIndex) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            const isSingleStep = steps.length <= 1;
                            const isLast = stepIndex === steps.length - 1;
                            const isFirst = stepIndex === 0;
                            __jade_nodes = __jade_nodes.concat((step.canAddReverseStep && !$attr(`disable-add-step`)) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                ".sankey-table-column.break-header.reverse": true,
                                "class": Object.assign({}, {
                                  'is-first': isFirst,
                                  'is-single-step': isSingleStep
                                }, {
                                  'sankey-table-column': true,
                                  'break-header': true,
                                  'reverse': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'button-option-container': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: JSON.stringify({
                                        'leftIcon': `plus`
                                      }),
                                      'icon-only': !isSingleStep,
                                      'selected-option': addStepsText,
                                      'menu-width': 110,
                                      'never-show-caret': true,
                                      'disable-search': true,
                                      sections: JSON.stringify($helpers.getAddStepsSections()),
                                      'theme': `secondary`,
                                    }),
                                    "props": {
                                      boundaryEl: $helpers.getScrollElement(),
                                    },
                                    "on": {
                                      change: ev => $helpers.updateSteps({
                                        operation: `add`,
                                        type: `reverse`,
                                        anchor: step.anchor,
                                        absolute: $helpers.getAbsoluteSteps({
                                          step,
                                          operation: `add`,
                                          value: ev.detail.item.value
                                        })
                                      }),
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(" ");;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat((!isSingleStep) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        placement: isFirst ? `right` : `bottom`,
                                        'offset': `5`
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(addStepsText)]));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : undefined);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            const removeStepsByColumn = (step.isForward || step.isReverse) && !$attr(`disable-add-step`);;
                            const inRemoveRange = $helpers.isInRemoveRange(step);;
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "on": {
                                click: () => removeStepsByColumn ? $helpers.updateSteps({
                                  operation: `remove`,
                                  type: step.isForward ? `forward` : `reverse`,
                                  anchor: step.anchor,
                                  absolute: $helpers.getAbsoluteSteps({
                                    step,
                                    operation: `remove`,
                                    value: 1
                                  })
                                }) : {},
                                mouseenter: () => removeStepsByColumn ? $helpers.onRemoveStepHover(step) : {},
                                mouseleave: () => removeStepsByColumn ? $helpers.onRemoveStepHover(step) : {},
                              },
                              "class": Object.assign({}, {
                                'in-remove-range': inRemoveRange,
                                'highlight-for-removal': removeStepsByColumn,
                                'has-context_menu': displayContextMenu,
                                'is-step-column': true,
                                'is-last': isLast
                              }, {
                                'sankey-table-column': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", {
                                "on": {
                                  click: () => $helpers.onColumnHeaderClick(stepIndex)
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((stepIndex !== 0) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'sankey-header-arrow-white': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat((step.isNormalAnchor) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": Object.assign({}, {
                                      'is-first': isFirst
                                    }, {
                                      'sankey-header-column-label-wrapper': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(($attr(`disable-anchor-event-labels`)) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("sankey-header-column-name", (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat("Step " + (stepIndex + 1) + "");;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'sankey-header-column-letter-label': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(step.getLetterLabel);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));
                                      __jade_nodes = __jade_nodes.concat(h("sankey-header-column-name", (function() {
                                        var __jade_nodes = [];
                                        const originalLabel = step.getStepLabel();
                                        const stepLabel = (originalLabel && originalLabel.length > 20) ? $helpers.truncateLabel(originalLabel, 20) : originalLabel;
                                        __jade_nodes = __jade_nodes.concat(stepLabel);
                                        __jade_nodes = __jade_nodes.concat((originalLabel && originalLabel.length > 20) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                            "attrs": __vjadeStringifyAttrsIfObj({
                                              placement: `bottom`,
                                              'offset': `-5px`,
                                              'max-width': `300px`
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(originalLabel)]));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat((removeStepsByColumn) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("remove-events", (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        icon: 'dash'
                                      }),
                                    }));
                                    __jade_nodes = __jade_nodes.concat((step.canAddForwardStep || step.canAddReverseStep) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(`Remove Step`);;
                                      return __jade_nodes
                                    }).call(this)) : ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(`Remove Steps`);;
                                      return __jade_nodes
                                    }).call(this)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat((stepIndex !== steps.length - 1) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'sankey-header-arrow-gray': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && !$attr(`disable-add-step`)) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'is-single-step': isSingleStep,
                                  'is-last': isLast
                                }, {
                                  'sankey-table-column': true,
                                  'break-header': true,
                                  'forward': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'button-option-container': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: JSON.stringify({
                                        'leftIcon': `plus`
                                      }),
                                      'icon-only': !isSingleStep,
                                      'selected-option': addStepsText,
                                      'menu-width': 110,
                                      'disable-search': true,
                                      'never-show-caret': true,
                                      sections: JSON.stringify($helpers.getAddStepsSections()),
                                      'theme': `secondary`,
                                    }),
                                    "props": {
                                      boundaryEl: $helpers.getScrollElement(),
                                    },
                                    "on": {
                                      change: ev => $helpers.updateSteps({
                                        operation: `add`,
                                        type: `forward`,
                                        anchor: step.anchor,
                                        absolute: $helpers.getAbsoluteSteps({
                                          step,
                                          operation: `add`,
                                          value: ev.detail.item.value
                                        })
                                      }),
                                    },
                                  }));
                                  __jade_nodes = __jade_nodes.concat((!isSingleStep) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        placement: isLast ? `left` : `bottom`,
                                        'offset': `5`
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(addStepsText)]));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : undefined);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && stepIndex < steps.length - 1) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'sankey-table-column': true,
                                  'break-header': true,
                                  'break': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    icon: `wave`
                                  }),
                                }));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'break': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var stepIndex = $$objKey;
                            if ($$obj.hasOwnProperty(stepIndex)) {
                              $$iterated = true;
                              var step = $$obj[stepIndex];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                const isSingleStep = steps.length <= 1;
                                const isLast = stepIndex === steps.length - 1;
                                const isFirst = stepIndex === 0;
                                __jade_nodes = __jade_nodes.concat((step.canAddReverseStep && !$attr(`disable-add-step`)) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    ".sankey-table-column.break-header.reverse": true,
                                    "class": Object.assign({}, {
                                      'is-first': isFirst,
                                      'is-single-step': isSingleStep
                                    }, {
                                      'sankey-table-column': true,
                                      'break-header': true,
                                      'reverse': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'button-option-container': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                        "attrs": __vjadeStringifyAttrsIfObj({
                                          icon: JSON.stringify({
                                            'leftIcon': `plus`
                                          }),
                                          'icon-only': !isSingleStep,
                                          'selected-option': addStepsText,
                                          'menu-width': 110,
                                          'never-show-caret': true,
                                          'disable-search': true,
                                          sections: JSON.stringify($helpers.getAddStepsSections()),
                                          'theme': `secondary`,
                                        }),
                                        "props": {
                                          boundaryEl: $helpers.getScrollElement(),
                                        },
                                        "on": {
                                          change: ev => $helpers.updateSteps({
                                            operation: `add`,
                                            type: `reverse`,
                                            anchor: step.anchor,
                                            absolute: $helpers.getAbsoluteSteps({
                                              step,
                                              operation: `add`,
                                              value: ev.detail.item.value
                                            })
                                          }),
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(" ");;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));
                                      __jade_nodes = __jade_nodes.concat((!isSingleStep) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                          "attrs": __vjadeStringifyAttrsIfObj({
                                            placement: isFirst ? `right` : `bottom`,
                                            'offset': `5`
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(addStepsText)]));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                const removeStepsByColumn = (step.isForward || step.isReverse) && !$attr(`disable-add-step`);;
                                const inRemoveRange = $helpers.isInRemoveRange(step);;
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "on": {
                                    click: () => removeStepsByColumn ? $helpers.updateSteps({
                                      operation: `remove`,
                                      type: step.isForward ? `forward` : `reverse`,
                                      anchor: step.anchor,
                                      absolute: $helpers.getAbsoluteSteps({
                                        step,
                                        operation: `remove`,
                                        value: 1
                                      })
                                    }) : {},
                                    mouseenter: () => removeStepsByColumn ? $helpers.onRemoveStepHover(step) : {},
                                    mouseleave: () => removeStepsByColumn ? $helpers.onRemoveStepHover(step) : {},
                                  },
                                  "class": Object.assign({}, {
                                    'in-remove-range': inRemoveRange,
                                    'highlight-for-removal': removeStepsByColumn,
                                    'has-context_menu': displayContextMenu,
                                    'is-step-column': true,
                                    'is-last': isLast
                                  }, {
                                    'sankey-table-column': true
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "on": {
                                      click: () => $helpers.onColumnHeaderClick(stepIndex)
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((stepIndex !== 0) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'sankey-header-arrow-white': true
                                        },
                                      }));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);
                                    __jade_nodes = __jade_nodes.concat((step.isNormalAnchor) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": Object.assign({}, {
                                          'is-first': isFirst
                                        }, {
                                          'sankey-header-column-label-wrapper': true
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(($attr(`disable-anchor-event-labels`)) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("sankey-header-column-name", (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat("Step " + (stepIndex + 1) + "");;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'sankey-header-column-letter-label': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(step.getLetterLabel);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));
                                          __jade_nodes = __jade_nodes.concat(h("sankey-header-column-name", (function() {
                                            var __jade_nodes = [];
                                            const originalLabel = step.getStepLabel();
                                            const stepLabel = (originalLabel && originalLabel.length > 20) ? $helpers.truncateLabel(originalLabel, 20) : originalLabel;
                                            __jade_nodes = __jade_nodes.concat(stepLabel);
                                            __jade_nodes = __jade_nodes.concat((originalLabel && originalLabel.length > 20) ? ((function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                                "attrs": __vjadeStringifyAttrsIfObj({
                                                  placement: `bottom`,
                                                  'offset': `-5px`,
                                                  'max-width': `300px`
                                                }),
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(originalLabel)]));;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this)) : undefined);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);
                                    __jade_nodes = __jade_nodes.concat((removeStepsByColumn) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("remove-events", (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                          "attrs": __vjadeStringifyAttrsIfObj({
                                            icon: 'dash'
                                          }),
                                        }));
                                        __jade_nodes = __jade_nodes.concat((step.canAddForwardStep || step.canAddReverseStep) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(`Remove Step`);;
                                          return __jade_nodes
                                        }).call(this)) : ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(`Remove Steps`);;
                                          return __jade_nodes
                                        }).call(this)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);
                                    __jade_nodes = __jade_nodes.concat((stepIndex !== steps.length - 1) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'sankey-header-arrow-gray': true
                                        },
                                      }));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && !$attr(`disable-add-step`)) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": Object.assign({}, {
                                      'is-single-step': isSingleStep,
                                      'is-last': isLast
                                    }, {
                                      'sankey-table-column': true,
                                      'break-header': true,
                                      'forward': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'button-option-container': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                        "attrs": __vjadeStringifyAttrsIfObj({
                                          icon: JSON.stringify({
                                            'leftIcon': `plus`
                                          }),
                                          'icon-only': !isSingleStep,
                                          'selected-option': addStepsText,
                                          'menu-width': 110,
                                          'disable-search': true,
                                          'never-show-caret': true,
                                          sections: JSON.stringify($helpers.getAddStepsSections()),
                                          'theme': `secondary`,
                                        }),
                                        "props": {
                                          boundaryEl: $helpers.getScrollElement(),
                                        },
                                        "on": {
                                          change: ev => $helpers.updateSteps({
                                            operation: `add`,
                                            type: `forward`,
                                            anchor: step.anchor,
                                            absolute: $helpers.getAbsoluteSteps({
                                              step,
                                              operation: `add`,
                                              value: ev.detail.item.value
                                            })
                                          }),
                                        },
                                      }));
                                      __jade_nodes = __jade_nodes.concat((!isSingleStep) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                          "attrs": __vjadeStringifyAttrsIfObj({
                                            placement: isLast ? `left` : `bottom`,
                                            'offset': `5`
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(addStepsText)]));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && stepIndex < steps.length - 1) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'sankey-table-column': true,
                                      'break-header': true,
                                      'break': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        icon: `wave`
                                      }),
                                    }));
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'break': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-table-body': true
                    },
                  }, (function() {
                    var __jade_nodes = []; /*  link shapes for all nodes */
                    __jade_nodes = __jade_nodes.concat(h("svg", {
                      "class": {
                        'sankey-links': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = ((links || []));
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, link, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("path", {
                                "attrs": __vjadeStringifyAttrsIfObj(link.attrs),
                                "props": link.props,
                                "style": {
                                  '--breakdown-bg-color': link.color
                                },
                                "class": link.class,
                              }));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var link = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("path", {
                                    "attrs": __vjadeStringifyAttrsIfObj(link.attrs),
                                    "props": link.props,
                                    "style": {
                                      '--breakdown-bg-color': link.color
                                    },
                                    "class": link.class,
                                  }));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (steps);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, step, stepIndex) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            const isSingleStep = steps.length <= 1;
                            const isLast = stepIndex === steps.length - 1;
                            const isFirst = stepIndex === 0;
                            __jade_nodes = __jade_nodes.concat((step.canAddReverseStep && !$attr(`disable-add-step`)) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'is-first': isFirst,
                                  'is-single-step': isSingleStep
                                }, {
                                  'sankey-table-column': true,
                                  'break-body': true,
                                  'reverse': true
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": Object.assign({}, {
                                'is-step-column': true,
                                'is-last': isLast
                              }, {
                                'sankey-table-column': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat((step.nodes.length > 0) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((function() {
                                  var $$obj = (step.nodes);
                                  var $$eachNodes;
                                  var $$iterated = false;
                                  if (Array.isArray($$obj)) {
                                    $$eachNodes = $$obj.reduce(function($$eachNodes, node, $index) {
                                      $$iterated = true;
                                      return $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        const nodeAttributes = $helpers.getNodeAttributes(node, step);;
                                        const isLastNode = step.nodes[step.nodes.length - 1] === node;;
                                        const marginPadding = $helpers.getBottomMarginPadding(nodeAttributes.height, isLastNode);;
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            'margin-bottom': `${marginPadding}px`
                                          },
                                          "class": {
                                            'sankey-node-wrapper': true
                                          },
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "dataset": {
                                              id: node.id
                                            },
                                            "on": {
                                              click: $helpers.onNodeClicked,
                                              contextmenu: ev => $helpers.showContextMenu(ev, node),
                                            },
                                            "props": {
                                              node
                                            },
                                            "class": Object.assign({}, {
                                              'is-active': selectedNode === node.id,
                                              'is-in-top-path': nodeAttributes.isInTopPath,
                                              [`is-${nodeAttributes.nodeType}`]: true,
                                            }, {
                                              'sankey-node': true
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat((function() {
                                              var $$obj = (node.breakdowns);
                                              var $$eachNodes;
                                              var $$iterated = false;
                                              if (Array.isArray($$obj)) {
                                                $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                  $$iterated = true;
                                                  return $$eachNodes.concat((function() {
                                                    var __jade_nodes = [];
                                                    const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                                      "style": {
                                                        height: `${breakdownAttributes.height}px`,
                                                        '--breakdown-bg-color': breakdownAttributes.color
                                                      },
                                                      "class": Object.assign({}, {
                                                        'is-active': selectedNode === node.id,
                                                        'in-remove-range': nodeAttributes.isInRemoveRange,
                                                        'is-broken-down': breakdowns.length > 1,
                                                        [`is-${nodeAttributes.nodeType}`]: true
                                                      }, {
                                                        'sankey-node-breakdown': true
                                                      }),
                                                    }));;
                                                    return __jade_nodes
                                                  }).call(this));
                                                }, []);
                                              } else {
                                                $$eachNodes = [];
                                                for (var $$objKey in $$obj) {
                                                  (function() {
                                                    var $index = $$objKey;
                                                    if ($$obj.hasOwnProperty($index)) {
                                                      $$iterated = true;
                                                      var breakdown = $$obj[$index];
                                                      $$eachNodes = $$eachNodes.concat((function() {
                                                        var __jade_nodes = [];
                                                        const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                                          "style": {
                                                            height: `${breakdownAttributes.height}px`,
                                                            '--breakdown-bg-color': breakdownAttributes.color
                                                          },
                                                          "class": Object.assign({}, {
                                                            'is-active': selectedNode === node.id,
                                                            'in-remove-range': nodeAttributes.isInRemoveRange,
                                                            'is-broken-down': breakdowns.length > 1,
                                                            [`is-${nodeAttributes.nodeType}`]: true
                                                          }, {
                                                            'sankey-node-breakdown': true
                                                          }),
                                                        }));;
                                                        return __jade_nodes
                                                      }).call(this));
                                                    }
                                                  })();
                                                }
                                              }

                                              return $$eachNodes;
                                            })());;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                            node,
                                            nodeAttributes,
                                            anchorStepWeight
                                          }));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this));
                                    }, []);
                                  } else {
                                    $$eachNodes = [];
                                    for (var $$objKey in $$obj) {
                                      (function() {
                                        var $index = $$objKey;
                                        if ($$obj.hasOwnProperty($index)) {
                                          $$iterated = true;
                                          var node = $$obj[$index];
                                          $$eachNodes = $$eachNodes.concat((function() {
                                            var __jade_nodes = [];
                                            const nodeAttributes = $helpers.getNodeAttributes(node, step);;
                                            const isLastNode = step.nodes[step.nodes.length - 1] === node;;
                                            const marginPadding = $helpers.getBottomMarginPadding(nodeAttributes.height, isLastNode);;
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                'margin-bottom': `${marginPadding}px`
                                              },
                                              "class": {
                                                'sankey-node-wrapper': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "dataset": {
                                                  id: node.id
                                                },
                                                "on": {
                                                  click: $helpers.onNodeClicked,
                                                  contextmenu: ev => $helpers.showContextMenu(ev, node),
                                                },
                                                "props": {
                                                  node
                                                },
                                                "class": Object.assign({}, {
                                                  'is-active': selectedNode === node.id,
                                                  'is-in-top-path': nodeAttributes.isInTopPath,
                                                  [`is-${nodeAttributes.nodeType}`]: true,
                                                }, {
                                                  'sankey-node': true
                                                }),
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat((function() {
                                                  var $$obj = (node.breakdowns);
                                                  var $$eachNodes;
                                                  var $$iterated = false;
                                                  if (Array.isArray($$obj)) {
                                                    $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                      $$iterated = true;
                                                      return $$eachNodes.concat((function() {
                                                        var __jade_nodes = [];
                                                        const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                                          "style": {
                                                            height: `${breakdownAttributes.height}px`,
                                                            '--breakdown-bg-color': breakdownAttributes.color
                                                          },
                                                          "class": Object.assign({}, {
                                                            'is-active': selectedNode === node.id,
                                                            'in-remove-range': nodeAttributes.isInRemoveRange,
                                                            'is-broken-down': breakdowns.length > 1,
                                                            [`is-${nodeAttributes.nodeType}`]: true
                                                          }, {
                                                            'sankey-node-breakdown': true
                                                          }),
                                                        }));;
                                                        return __jade_nodes
                                                      }).call(this));
                                                    }, []);
                                                  } else {
                                                    $$eachNodes = [];
                                                    for (var $$objKey in $$obj) {
                                                      (function() {
                                                        var $index = $$objKey;
                                                        if ($$obj.hasOwnProperty($index)) {
                                                          $$iterated = true;
                                                          var breakdown = $$obj[$index];
                                                          $$eachNodes = $$eachNodes.concat((function() {
                                                            var __jade_nodes = [];
                                                            const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                                              "style": {
                                                                height: `${breakdownAttributes.height}px`,
                                                                '--breakdown-bg-color': breakdownAttributes.color
                                                              },
                                                              "class": Object.assign({}, {
                                                                'is-active': selectedNode === node.id,
                                                                'in-remove-range': nodeAttributes.isInRemoveRange,
                                                                'is-broken-down': breakdowns.length > 1,
                                                                [`is-${nodeAttributes.nodeType}`]: true
                                                              }, {
                                                                'sankey-node-breakdown': true
                                                              }),
                                                            }));;
                                                            return __jade_nodes
                                                          }).call(this));
                                                        }
                                                      })();
                                                    }
                                                  }

                                                  return $$eachNodes;
                                                })());;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                                node,
                                                nodeAttributes,
                                                anchorStepWeight
                                              }));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this));
                                        }
                                      })();
                                    }
                                  }

                                  return $$eachNodes;
                                })());;
                                return __jade_nodes
                              }).call(this)) : ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'sankey-empty-column': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(`No Data`);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && !$attr(`disable-add-step`)) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'is-single-step': isSingleStep,
                                  'is-last': isLast
                                }, {
                                  'sankey-table-column': true,
                                  'break-body': true,
                                  'forward': true
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && stepIndex < steps.length - 1) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'sankey-table-column': true,
                                  'break-body': true,
                                  'break': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'break': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var stepIndex = $$objKey;
                            if ($$obj.hasOwnProperty(stepIndex)) {
                              $$iterated = true;
                              var step = $$obj[stepIndex];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                const isSingleStep = steps.length <= 1;
                                const isLast = stepIndex === steps.length - 1;
                                const isFirst = stepIndex === 0;
                                __jade_nodes = __jade_nodes.concat((step.canAddReverseStep && !$attr(`disable-add-step`)) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": Object.assign({}, {
                                      'is-first': isFirst,
                                      'is-single-step': isSingleStep
                                    }, {
                                      'sankey-table-column': true,
                                      'break-body': true,
                                      'reverse': true
                                    }),
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": Object.assign({}, {
                                    'is-step-column': true,
                                    'is-last': isLast
                                  }, {
                                    'sankey-table-column': true
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat((step.nodes.length > 0) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((function() {
                                      var $$obj = (step.nodes);
                                      var $$eachNodes;
                                      var $$iterated = false;
                                      if (Array.isArray($$obj)) {
                                        $$eachNodes = $$obj.reduce(function($$eachNodes, node, $index) {
                                          $$iterated = true;
                                          return $$eachNodes.concat((function() {
                                            var __jade_nodes = [];
                                            const nodeAttributes = $helpers.getNodeAttributes(node, step);;
                                            const isLastNode = step.nodes[step.nodes.length - 1] === node;;
                                            const marginPadding = $helpers.getBottomMarginPadding(nodeAttributes.height, isLastNode);;
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                'margin-bottom': `${marginPadding}px`
                                              },
                                              "class": {
                                                'sankey-node-wrapper': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "dataset": {
                                                  id: node.id
                                                },
                                                "on": {
                                                  click: $helpers.onNodeClicked,
                                                  contextmenu: ev => $helpers.showContextMenu(ev, node),
                                                },
                                                "props": {
                                                  node
                                                },
                                                "class": Object.assign({}, {
                                                  'is-active': selectedNode === node.id,
                                                  'is-in-top-path': nodeAttributes.isInTopPath,
                                                  [`is-${nodeAttributes.nodeType}`]: true,
                                                }, {
                                                  'sankey-node': true
                                                }),
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat((function() {
                                                  var $$obj = (node.breakdowns);
                                                  var $$eachNodes;
                                                  var $$iterated = false;
                                                  if (Array.isArray($$obj)) {
                                                    $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                      $$iterated = true;
                                                      return $$eachNodes.concat((function() {
                                                        var __jade_nodes = [];
                                                        const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                                          "style": {
                                                            height: `${breakdownAttributes.height}px`,
                                                            '--breakdown-bg-color': breakdownAttributes.color
                                                          },
                                                          "class": Object.assign({}, {
                                                            'is-active': selectedNode === node.id,
                                                            'in-remove-range': nodeAttributes.isInRemoveRange,
                                                            'is-broken-down': breakdowns.length > 1,
                                                            [`is-${nodeAttributes.nodeType}`]: true
                                                          }, {
                                                            'sankey-node-breakdown': true
                                                          }),
                                                        }));;
                                                        return __jade_nodes
                                                      }).call(this));
                                                    }, []);
                                                  } else {
                                                    $$eachNodes = [];
                                                    for (var $$objKey in $$obj) {
                                                      (function() {
                                                        var $index = $$objKey;
                                                        if ($$obj.hasOwnProperty($index)) {
                                                          $$iterated = true;
                                                          var breakdown = $$obj[$index];
                                                          $$eachNodes = $$eachNodes.concat((function() {
                                                            var __jade_nodes = [];
                                                            const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                                              "style": {
                                                                height: `${breakdownAttributes.height}px`,
                                                                '--breakdown-bg-color': breakdownAttributes.color
                                                              },
                                                              "class": Object.assign({}, {
                                                                'is-active': selectedNode === node.id,
                                                                'in-remove-range': nodeAttributes.isInRemoveRange,
                                                                'is-broken-down': breakdowns.length > 1,
                                                                [`is-${nodeAttributes.nodeType}`]: true
                                                              }, {
                                                                'sankey-node-breakdown': true
                                                              }),
                                                            }));;
                                                            return __jade_nodes
                                                          }).call(this));
                                                        }
                                                      })();
                                                    }
                                                  }

                                                  return $$eachNodes;
                                                })());;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                                node,
                                                nodeAttributes,
                                                anchorStepWeight
                                              }));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this));
                                        }, []);
                                      } else {
                                        $$eachNodes = [];
                                        for (var $$objKey in $$obj) {
                                          (function() {
                                            var $index = $$objKey;
                                            if ($$obj.hasOwnProperty($index)) {
                                              $$iterated = true;
                                              var node = $$obj[$index];
                                              $$eachNodes = $$eachNodes.concat((function() {
                                                var __jade_nodes = [];
                                                const nodeAttributes = $helpers.getNodeAttributes(node, step);;
                                                const isLastNode = step.nodes[step.nodes.length - 1] === node;;
                                                const marginPadding = $helpers.getBottomMarginPadding(nodeAttributes.height, isLastNode);;
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "style": {
                                                    'margin-bottom': `${marginPadding}px`
                                                  },
                                                  "class": {
                                                    'sankey-node-wrapper': true
                                                  },
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                                    "dataset": {
                                                      id: node.id
                                                    },
                                                    "on": {
                                                      click: $helpers.onNodeClicked,
                                                      contextmenu: ev => $helpers.showContextMenu(ev, node),
                                                    },
                                                    "props": {
                                                      node
                                                    },
                                                    "class": Object.assign({}, {
                                                      'is-active': selectedNode === node.id,
                                                      'is-in-top-path': nodeAttributes.isInTopPath,
                                                      [`is-${nodeAttributes.nodeType}`]: true,
                                                    }, {
                                                      'sankey-node': true
                                                    }),
                                                  }, (function() {
                                                    var __jade_nodes = [];
                                                    __jade_nodes = __jade_nodes.concat((function() {
                                                      var $$obj = (node.breakdowns);
                                                      var $$eachNodes;
                                                      var $$iterated = false;
                                                      if (Array.isArray($$obj)) {
                                                        $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                          $$iterated = true;
                                                          return $$eachNodes.concat((function() {
                                                            var __jade_nodes = [];
                                                            const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                                              "style": {
                                                                height: `${breakdownAttributes.height}px`,
                                                                '--breakdown-bg-color': breakdownAttributes.color
                                                              },
                                                              "class": Object.assign({}, {
                                                                'is-active': selectedNode === node.id,
                                                                'in-remove-range': nodeAttributes.isInRemoveRange,
                                                                'is-broken-down': breakdowns.length > 1,
                                                                [`is-${nodeAttributes.nodeType}`]: true
                                                              }, {
                                                                'sankey-node-breakdown': true
                                                              }),
                                                            }));;
                                                            return __jade_nodes
                                                          }).call(this));
                                                        }, []);
                                                      } else {
                                                        $$eachNodes = [];
                                                        for (var $$objKey in $$obj) {
                                                          (function() {
                                                            var $index = $$objKey;
                                                            if ($$obj.hasOwnProperty($index)) {
                                                              $$iterated = true;
                                                              var breakdown = $$obj[$index];
                                                              $$eachNodes = $$eachNodes.concat((function() {
                                                                var __jade_nodes = [];
                                                                const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                                  "style": {
                                                                    height: `${breakdownAttributes.height}px`,
                                                                    '--breakdown-bg-color': breakdownAttributes.color
                                                                  },
                                                                  "class": Object.assign({}, {
                                                                    'is-active': selectedNode === node.id,
                                                                    'in-remove-range': nodeAttributes.isInRemoveRange,
                                                                    'is-broken-down': breakdowns.length > 1,
                                                                    [`is-${nodeAttributes.nodeType}`]: true
                                                                  }, {
                                                                    'sankey-node-breakdown': true
                                                                  }),
                                                                }));;
                                                                return __jade_nodes
                                                              }).call(this));
                                                            }
                                                          })();
                                                        }
                                                      }

                                                      return $$eachNodes;
                                                    })());;
                                                    return __jade_nodes
                                                  }).call(this).filter(Boolean)));
                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                                    node,
                                                    nodeAttributes,
                                                    anchorStepWeight
                                                  }));;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this));
                                            }
                                          })();
                                        }
                                      }

                                      return $$eachNodes;
                                    })());;
                                    return __jade_nodes
                                  }).call(this)) : ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'sankey-empty-column': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(`No Data`);;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && !$attr(`disable-add-step`)) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": Object.assign({}, {
                                      'is-single-step': isSingleStep,
                                      'is-last': isLast
                                    }, {
                                      'sankey-table-column': true,
                                      'break-body': true,
                                      'forward': true
                                    }),
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat((step.canAddForwardStep && stepIndex < steps.length - 1) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'sankey-table-column': true,
                                      'break-body': true,
                                      'break': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'break': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "displayContextMenu" in locals ? locals.displayContextMenu : typeof displayContextMenu !== "undefined" ? displayContextMenu : undefined, "labelsCropped" in locals ? locals.labelsCropped : typeof labelsCropped !== "undefined" ? labelsCropped : undefined, "links" in locals ? locals.links : typeof links !== "undefined" ? links : undefined, "selectedNode" in locals ? locals.selectedNode : typeof selectedNode !== "undefined" ? selectedNode : undefined, "tooltip" in locals ? locals.tooltip : typeof tooltip !== "undefined" ? tooltip : undefined, "topPath" in locals ? locals.topPath : typeof topPath !== "undefined" ? topPath : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;